import Component from '@glimmer/component';

export default class HelpModal extends Component {
  tagName = '';
  marker = null;

  constructor() {
    super(...arguments);
    if (this.args.marker) {
      this.args.marker();
    }
  }
}
